import { CALL_API } from '../../api/';
import { Schemas } from '../../api/schema';
import * as ActionTypes from './actionTypes';

// Create a booking
const createBooking = (booking) => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_BOOKING_REQUEST,
      ActionTypes.CREATE_BOOKING_SUCCESS,
      ActionTypes.CREATE_BOOKING_FAILURE,
      ],
    endpoint: `bookings`,
    schema: Schemas.BOOKING
  }
});

// createBooking action creator
export const makeBooking = (booking) => (dispatch, getState) => {
  return dispatch(createBooking(booking));
};

// Initiate payment
const createPayment = (payment) => ({
  [CALL_API]: {
    types: [
      ActionTypes.INITIATE_PAYMENT_REQUEST,
      ActionTypes.INITIATE_PAYMENT_SUCCESS,
      ActionTypes.INITIATE_PAYMENT_FAILURE,
      ],
    endpoint: `payments`,
    schema: Schemas.PAYMENT
  }
});

// initiatePayment action creator
export const initiatePayment = (payment) => (dispatch, getState) => {
  return dispatch(createPayment(payment));
};


// WEBPACK FOOTER //
// ./src/modules/booking/actions.js